import { styled } from '@mui/material/styles'
import { Button } from '@mui/material'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'

const RightButton = styled(Button)(({ theme }) => ({
  color: theme.palette.primary.contrastText,
  paddingLeft: '5px',
  '&:hover': {
    color: theme.palette.grey[50]
  }
}))

const SeeAllBtn = ({ isDisable = false, onClick = () => {} }: any) => {
  return (
    <RightButton
        onClick={onClick}
        disabled={isDisable}
      endIcon={<ArrowForwardIcon sx={{ width: 15 }} />}
    >
      See All
    </RightButton>
  )
}

export default SeeAllBtn
